var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacketWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.176 44.33L140.305 58.5619L123.176 63.0967V44.33ZM84.0028 53.1459C85.5144 55.2871 88.1594 56.4204 90.8044 55.791C93.4494 55.1614 95.2124 52.7678 95.3392 50.1229L120.529 43.3213V63.7253L114.861 65.2369C114.232 65.3626 113.854 66.1189 113.979 66.8742C114.483 68.7639 113.35 70.6526 111.46 71.1566C109.697 71.6605 107.933 70.6527 107.177 68.8897C107.177 68.2602 106.548 67.7563 105.792 67.7563H105.413L78.2087 75.0619L59.5688 59.6967L84.0028 53.1459ZM58.1831 61.963L66.1182 68.5122V130.228L58.1831 137.785V61.963ZM66.8735 133L74.9344 154.16L58.8129 140.81L66.8735 133ZM68.7633 130.355V70.653L76.6984 77.2022V151.261L68.7633 130.355ZM79.3433 156.68V77.5812L105.037 70.6538C106.045 72.6693 108.186 73.9283 110.453 73.9283C110.957 73.9283 111.461 73.8026 112.09 73.6769C114.861 72.9216 116.751 70.4024 116.625 67.379L141.815 60.5774V139.676L79.3433 156.68ZM102.896 62.8445C103.652 62.8445 104.282 63.4741 104.282 64.2304C104.282 64.9857 103.653 65.6163 102.896 65.6163C102.141 65.6163 101.51 64.9867 101.51 64.2304C101.51 63.4741 102.14 62.8445 102.896 62.8445Z",
    fill: "#9FADB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.855 149.131C153.606 149.131 163.132 139.606 163.132 127.855C163.132 116.104 153.606 106.579 141.855 106.579C130.105 106.579 120.579 116.104 120.579 127.855C120.579 139.606 130.105 149.131 141.855 149.131Z",
    fill: "#5A646A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.855 140.266C143.324 140.266 144.515 139.076 144.515 137.607C144.515 136.138 143.324 134.947 141.855 134.947C140.387 134.947 139.196 136.138 139.196 137.607C139.196 139.076 140.387 140.266 141.855 140.266Z",
    fill: "#ECF0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.855 117.217V129.628",
    stroke: "#ECF0F3",
    strokeWidth: 2.83684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketWarning);
export default __webpack_public_path__ + "static/media/packet-warning.da6670fca07390afc47571dfe3766a1d.svg";
export { ForwardRef as ReactComponent };